import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./Header";
import LandingPage from "./LandingPage";
import AboutMe from "./AboutMe";
import Projects from "./Projects";
import Contact from "./Contact";
import Footer from "./Footer";
import ProjectDetailPage from "./ProjectDetailPage/ProjectDetailPage";
import { about, projects, socials } from "./content/siteContent";

import "./style/App.css";

function App() {
  return (
    <Router>
      <div className="app">
        <Header projects={projects} />
        <main className="app-content">
          <Routes>
            <Route
              path="/"
              element={<LandingPage about={about} projects={projects} />}
            />
            <Route path="/about" element={<AboutMe about={about} />} />
            <Route path="/projects" element={<Projects projects={projects} />} />
            <Route path="/projects/:projectSlug" element={<ProjectDetailPage projects={projects} />} />
            <Route path="/contact" element={<Contact socials={socials} />} />
          </Routes>
        </main>
        <Footer socials={socials} />
      </div>
    </Router>
  );
}

export default App;
